/* ============================================================
   Potty Finder — quiz logic + render
   Native vanilla JS port of the Lovable React app. No deps.
   Scoring/recommendation logic mirrors lovable-source/src/lib/
   pottyRecommendation.ts verbatim (do not reshape — branding /
   product copy lives in there).
   ============================================================ */

(function () {
  'use strict';

  const ROOT_SELECTOR = '#potty-finder-root';
  const root = document.querySelector(ROOT_SELECTOR);
  if (!root) return;

  /* ------------------------------------------------------------
     Product catalogue — ported from lovable-source/src/lib/
     pottyRecommendation.ts. Reasons get overridden per-result.
     ------------------------------------------------------------ */
  const P = {
    quickFlip:           { name: "Quick Flip Built-in Toilet Seat", url: "/products/built-in-potty", handle: "built-in-potty", category: "Potty Seat", image: "https://joolbaby.com/cdn/shop/files/Jool_Baby_r2_6323-v1oec8nemr_cropped-w9xgcqq0ng.jpg?v=1752183350" },
    trainingSeat:        { name: "Potty Training Seat", url: "/products/toilet-traing-seat-for-boys-girls-aqua-splash-guard-non-slip-with-hook", handle: "toilet-traing-seat-for-boys-girls-aqua-splash-guard-non-slip-with-hook", category: "Potty Seat", image: "https://joolbaby.com/cdn/shop/files/Joolbaby_Potty_Training_Seat_Aqua_Main.png?v=1762358315" },
    trainingSeatHandles: { name: "Potty Training Seat with Handles", url: "/products/potty-training-seat-with-handles", handle: "potty-training-seat-with-handles", category: "Potty Seat", image: "https://joolbaby.com/cdn/shop/files/Jool_Baby_Handled_Potty_Seat_Aqua_Main.png?v=1742432851" },
    lockStep:            { name: "Lock 'n Step Folding Step Stool", url: "/products/lock-step-folding-step-stool-gray", handle: "lock-step-folding-step-stool-gray", category: "Step Stool", image: "https://joolbaby.com/cdn/shop/files/Jool_Baby_Lock_n_Step_Folding_Step_Stool_Grey_Main.png?v=1742322035" },
    clickClimb:          { name: "Click 'n Climb Locking Step Stool", url: "/products/jool-baby-click-n-climb-locking-step-stool-non-slip-carry-handle-white", handle: "jool-baby-click-n-climb-locking-step-stool-non-slip-carry-handle-white", category: "Step Stool", image: "https://joolbaby.com/cdn/shop/files/Screenshot_2025-06-10_at_12.34.28_PM.png?v=1750267737" },
    realFeel:            { name: "Real Feel Plus 2-in-1 Potty", url: "/products/real-feel-potty-chair", handle: "real-feel-potty-chair", category: "Potty Chair", image: "https://joolbaby.com/cdn/shop/files/Rfeel_Sage_2fbb6754-8d0d-4881-9a6b-edc1e64fd17d.jpg?v=1761923464" },
    onMyOwn2in1:         { name: "On My Own 2-in-1 Potty", url: "/products/2-in-1-potty", handle: "2-in-1-potty", category: "Potty Chair", image: "https://joolbaby.com/cdn/shop/files/2in1_Gry_Main.png?v=1752672182" },
    handledChair:        { name: "Handled Potty Chair", url: "/products/potty-training-chair-with-handles", handle: "potty-training-chair-with-handles", category: "Potty Chair", image: "https://joolbaby.com/cdn/shop/files/HFLP_PINK_1_24e40f7e-876a-4634-ac82-2fc4469c6632.png?v=1762450371" },
    milestone:           { name: "Milestone 4-in-1 Potty Training System", url: "/products/milestone-4-in-1-potty-system-white", handle: "milestone-4-in-1-potty-system-white", category: "Potty System", image: "https://joolbaby.com/cdn/shop/files/Jool_Baby__Milestone_4_in_1_Potty_Main.png?v=1773857350" },
    readyStepGo:         { name: "Ready, Step, Go! Potty Training Seat with 2 Step Ladder", url: "/products/potty-training-ladder-soft-cushioned-seat-adjustable-height-collapsible-non-slip-with-splash-guard", handle: "potty-training-ladder-soft-cushioned-seat-adjustable-height-collapsible-non-slip-with-splash-guard", category: "Potty Ladder", image: "https://joolbaby.com/cdn/shop/files/Main_A.png?v=1736454667" },
    onMyOwnLadder:       { name: "On My Own Potty Training Seat with Ladder", url: "/products/on-my-own-potty-ladder", handle: "on-my-own-potty-ladder", category: "Potty Ladder", image: "https://joolbaby.com/cdn/shop/files/JoolBaby_On_My_Own_Potty_Ladder_Lifestyle4.png?v=1768848178" },
    passport:            { name: "Passport Folding Travel Potty Seat", url: "/products/passport-folding-potty-seat", handle: "passport-folding-potty-seat", category: "Travel Potty", image: "https://joolbaby.com/cdn/shop/files/JoolBaby_Passport_Folding_Travel_Potty_Seat_White_Main.png?v=1758908455" },
    portableChair:       { name: "Portable Potty Chair", url: "/products/portable-potty-training-chair-with-travel-bag-foldable-indoor-outdoor-use-camping-includes-30-replacement-bags-jool-baby", handle: "portable-potty-training-chair-with-travel-bag-foldable-indoor-outdoor-use-camping-includes-30-replacement-bags-jool-baby", category: "Travel Potty", image: "https://joolbaby.com/cdn/shop/files/Travel_Potty_Chair_Side_Aqua.png?v=1758129236" },
    liners:              { name: "Potty Liners", url: "/products/potty-liners", handle: "potty-liners", category: "Add-on", image: "https://joolbaby.com/cdn/shop/files/Jool_Baby_Potty_Liners_Alt_1.png?v=1742988021" },
  };

  /* ------------------------------------------------------------
     Recommendation engine — verbatim port of recommend() from
     pottyRecommendation.ts. Same scoring, same branches, same
     copy. DO NOT REWRITE.
     ------------------------------------------------------------ */
  function buildAlts(primaryName, candidates) {
    const seen = new Set([primaryName]);
    const out = [];
    for (const c of candidates) {
      if (!c) continue;
      if (seen.has(c.name)) continue;
      seen.add(c.name);
      out.push(c);
      if (out.length >= 2) break;
    }
    return out.length ? out : undefined;
  }

  function recommend(a) {
    // Travel-first short circuit
    if (a.portability >= 5) {
      if (a.comfort >= 3) {
        const primary = Object.assign({}, P.passport, { reason: "Highly portable folding seat that fits in a bag — perfect for families on the go whose child is comfortable with the adult toilet." });
        return {
          primary,
          alternatives: buildAlts(primary.name, [
            a.comfort <= 4 && Object.assign({}, P.portableChair, { reason: "If your child isn't always confident on adult toilets while you're out, a standalone foldable chair is a reliable backup." }),
          ]),
          summary: "You need maximum portability and your child is okay with adult toilets — the Passport Folding Travel Potty Seat is your best match.",
        };
      }
      const primary = Object.assign({}, P.portableChair, { reason: "A standalone foldable potty chair for anywhere — ideal when there's no restroom and your child isn't yet comfortable with adult toilets." });
      return {
        primary,
        addon: Object.assign({}, P.liners, { reason: "Pair with disposable liners for mess-free cleanup on the road." }),
        alternatives: buildAlts(primary.name, [
          a.comfort >= 2 && Object.assign({}, P.passport, { reason: "Once your child warms up to adult toilets, a folding travel seat takes up almost no space in your bag." }),
        ]),
        summary: "Your child prefers a floor potty and you need something that can come with you everywhere. The Portable Potty Chair has you covered.",
      };
    }

    // Quick Flip short-circuit
    const quickFlipFit =
      a.portability <= 2 &&
      a.comfort >= 4 &&
      (a.independence >= 4 || a.noClean >= 4);
    if (quickFlipFit) {
      const stool = a.independence >= 4 || a.canClimb >= 4
        ? Object.assign({}, P.clickClimb, { reason: "Folding step stool with a carry handle — locks into place once opened to protect little fingers." })
        : Object.assign({}, P.lockStep, { reason: "Folding step stool that locks open so little fingers don't get pinched — easy to tuck away after use." });
      const primary = Object.assign({}, P.quickFlip, { reason: "Replaces your toilet seat with a built-in child seat — nothing to remove, nothing to clean. Perfect for a confident, independent kid at home who's already comfortable with the adult toilet." });
      return {
        primary,
        pairing: stool,
        alternatives: buildAlts(primary.name, [
          a.independence >= 4 && Object.assign({}, P.trainingSeatHandles, { reason: "Prefer not to swap out your toilet seat? A clip-on training seat with handles offers the same independence with no installation." }),
          a.canClimb >= 4 && a.independence >= 4 && Object.assign({}, P.readyStepGo, { reason: "A potty ladder is another fully-independent option if your climber loves doing it all themselves." }),
        ]),
        summary: "Your child is comfortable on the big toilet and you're not traveling — a built-in seat is the cleanest, most permanent solution.",
      };
    }

    // Score the three main "paths"
    const seatQualifies = a.comfort >= 2;
    const seatPath = seatQualifies
      ? a.comfort * 2 +
        a.noClean * 2 +
        (a.canClimb >= 3 ? 3 : -2) +
        (a.independence >= 4 && a.canPlaceSeat >= 4 ? 2 : 0)
      : -Infinity;

    const ladderQualifies = a.canClimb >= 4 && a.independence >= 4 && a.comfort >= 3;
    const ladderPath = ladderQualifies
      ? a.comfort * 1.5 +
        a.noClean * 1.5 +
        a.independence * 2 +
        a.canClimb * 2 +
        (a.canPlaceSeat >= 3 ? 1 : 0) -
        (a.portability >= 3 ? 2 : 0)
      : -Infinity;

    const chairPath =
      (6 - a.comfort) * 2 +
      (6 - a.canClimb) * 1.5 +
      (6 - a.canPlaceSeat) * 1 +
      (a.independence >= 3 ? 1 : 0);

    const max = Math.max(seatPath, ladderPath, chairPath);

    // ---- Potty seat (on the toilet) ----
    if (max === seatPath) {
      let primary;
      if (a.noClean >= 4 && a.comfort >= 4 && a.independence <= 3) {
        primary = Object.assign({}, P.quickFlip, { reason: "Replaces your toilet seat with a built-in child seat — nothing to remove, nothing to clean. Best when your child is comfortable with the adult toilet and you want zero hassle." });
      } else if (a.independence >= 4 || a.canPlaceSeat <= 2) {
        primary = Object.assign({}, P.trainingSeatHandles, { reason: "Built-in handles give your child something to grip, boosting independence and confidence on the big toilet." });
      } else {
        primary = Object.assign({}, P.trainingSeat, { reason: "Slip-resistant training seat that stays secure on the toilet — simple, effective, and easy to store with the included hook." });
      }

      const stool = a.independence >= 4 || a.canClimb >= 4
        ? Object.assign({}, P.clickClimb, { reason: "Folding step stool with a carry handle — locks into place once opened to protect little fingers." })
        : Object.assign({}, P.lockStep, { reason: "Folding step stool that locks open so little fingers don't get pinched — easy to tuck away after use." });

      return {
        primary,
        pairing: stool,
        alternatives: buildAlts(primary.name, [
          a.comfort >= 4 && a.portability <= 2 && Object.assign({}, P.quickFlip, { reason: "If you'd rather skip swapping seats every use, a built-in toilet seat is a permanent, low-maintenance upgrade." }),
          a.independence >= 4 && Object.assign({}, P.trainingSeatHandles, { reason: "If your child wants more grip and stability, the handled training seat boosts confidence." }),
          primary.name !== P.trainingSeat.name && Object.assign({}, P.trainingSeat, { reason: "A simple, no-frills training seat — easy to store and great if you don't need handles." }),
        ]),
        summary: "A potty seat on your existing toilet skips the transition step entirely — pair it with a step stool so your child can get up and down.",
      };
    }

    // ---- Potty ladder ----
    if (max === ladderPath) {
      const primary = a.canClimb >= 4
        ? Object.assign({}, P.readyStepGo, { reason: "An all-in-one potty seat with a 2-step ladder and adjustable height — built for confident climbers who want full independence." })
        : Object.assign({}, P.onMyOwnLadder, { reason: "A potty seat with a single-step ladder — a gentler climb for kids who are independent but not yet ready for a full ladder." });
      return {
        primary,
        alternatives: buildAlts(primary.name, [
          a.canClimb >= 4 && Object.assign({}, P.onMyOwnLadder, { reason: "A single-step option if you'd prefer something a little smaller and lower-profile." }),
          a.independence >= 4 && a.comfort <= 4 && Object.assign({}, P.milestone, { reason: "If you want one product that grows from floor potty to step stool to training seat, the 4-in-1 covers every stage." }),
        ]),
        summary: "Your child is independent and ready to climb — a potty ladder lets them get on the big toilet entirely on their own.",
      };
    }

    // ---- Potty chair (floor) ----
    let primary;
    let addon;

    if (a.noClean >= 4 && a.comfort <= 2) {
      primary = Object.assign({}, P.onMyOwn2in1, { reason: "Starts as a floor potty (so your child feels comfortable) and converts into a seat for the big toilet—easing the transition so you'll be free of cleaning out the insert as soon as possible." });
      addon = Object.assign({}, P.liners, { reason: "Use disposable liners while it's still on the floor — lift, toss, done. No scrubbing required." });
    } else if (a.comfort <= 2 && a.independence >= 4) {
      primary = Object.assign({}, P.handledChair, { reason: "Built-in handles and back support give scared or new-to-potty kids stability and a strong sense of independence." });
    } else if (a.comfort >= 3) {
      primary = Object.assign({}, P.realFeel, { reason: "Looks and feels like a real toilet, so kids who love to mimic adults love it — and the top comes off to use as a seat on the big toilet later." });
    } else if (a.independence >= 4 && a.canClimb >= 3) {
      primary = Object.assign({}, P.milestone, { reason: "A 4-in-1 system that grows with your child — floor potty, training seat, and step stool all in one (plus a urinal for boys). Maximum independence at every stage." });
    } else {
      primary = Object.assign({}, P.onMyOwn2in1, { reason: "Grows with your child — start as a floor potty, then convert to a toilet seat when they're ready. A safe, flexible first potty." });
    }

    if (a.noClean >= 4 && !addon) {
      addon = Object.assign({}, P.liners, { reason: "Disposable liners make cleanup nearly effortless while you're using a floor potty." });
    }

    const alternatives = buildAlts(primary.name, [
      a.comfort >= 3 && Object.assign({}, P.realFeel, { reason: "A realistic-looking potty for kids who love to mimic the grown-ups — the top doubles as a training seat later." }),
      a.independence >= 4 && Object.assign({}, P.milestone, { reason: "If you want one product that does it all (potty, step stool, training seat), the 4-in-1 grows with every stage." }),
      a.comfort <= 3 && Object.assign({}, P.handledChair, { reason: "Handles and back support add extra security for kids still getting comfortable." }),
      Object.assign({}, P.onMyOwn2in1, { reason: "A flexible 2-in-1 that starts on the floor and converts to a training seat when ready." }),
    ]);

    return {
      primary,
      addon,
      alternatives,
      summary: "A floor potty is the most comfortable starting point for kids who aren't yet ready for the adult toilet.",
    };
  }

  /* ------------------------------------------------------------
     Quiz config (questions + initial state)
     ------------------------------------------------------------ */
  const questions = [
    { key: "comfort",      title: "Is your child comfortable with the big toilet, or intimidated?",                   lowLabel: "Very scared",          highLabel: "Totally comfortable" },
    { key: "noClean",      title: "How important is it to you to NOT have to clean out a potty insert?",              lowLabel: "Don't mind cleaning",  highLabel: "Absolutely no insert" },
    { key: "canClimb",     title: "Is your child capable of climbing up a step stool or ladder to reach the toilet?", lowLabel: "Not yet",              highLabel: "Climbs confidently" },
    { key: "canPlaceSeat", title: "Can your child place the potty seat on the toilet themselves?",                    lowLabel: "No, needs help",       highLabel: "Yes, totally" },
    { key: "independence", title: "How important is it that your child can get on and off the potty themselves?",     lowLabel: "Not important",        highLabel: "Very important" },
    { key: "portability",  title: "How portable do you need the potty to be?",                                        lowLabel: "Stays in one room",    midLabel: "Needs to move around the house", highLabel: "Comes with us everywhere" },
  ];
  const defaultAnswers = { comfort: 3, noClean: 3, independence: 3, canClimb: 3, canPlaceSeat: 3, portability: 3 };
  const scaleLabel = (v) => ["", "Very low", "Low", "Neutral", "High", "Very high"][v];

  /* ------------------------------------------------------------
     Live product data — from Shopify product .js endpoint
     (price/availability that stays current automatically).
     Cache by handle so a re-take doesn't re-fetch.
     ------------------------------------------------------------ */
  const liveCache = {};
  function fetchProduct(handle) {
    if (liveCache[handle]) return Promise.resolve(liveCache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then((r) => r.ok ? r.json() : null)
      .then((data) => {
        if (!data) return null;
        const price = data.price;            // in cents
        const compare = data.compare_at_price;
        const out = {
          available: !!data.available,
          price: formatMoney(price),
          compareAtPrice: compare && compare > price ? formatMoney(compare) : undefined,
        };
        liveCache[handle] = out;
        return out;
      })
      .catch(() => null);
  }
  function formatMoney(cents) {
    const amt = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amt);
    } catch (_) {
      return '$' + amt.toFixed(2);
    }
  }

  /* ------------------------------------------------------------
     Tiny DOM helper — same idea as createElement but lighter.
     `h('div', {class:'foo'}, child, child, ...)`
     ------------------------------------------------------------ */
  function h(tag, attrs, ...children) {
    const el = document.createElement(tag);
    if (attrs) {
      for (const k in attrs) {
        if (k === 'class') el.className = attrs[k];
        else if (k === 'html') el.innerHTML = attrs[k];
        else if (k.startsWith('on') && typeof attrs[k] === 'function') el.addEventListener(k.slice(2).toLowerCase(), attrs[k]);
        else if (attrs[k] === false || attrs[k] == null) continue;
        else if (attrs[k] === true) el.setAttribute(k, '');
        else el.setAttribute(k, attrs[k]);
      }
    }
    for (const c of children) {
      if (c == null || c === false) continue;
      if (Array.isArray(c)) c.forEach((cc) => cc != null && cc !== false && el.appendChild(typeof cc === 'string' ? document.createTextNode(cc) : cc));
      else el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    }
    return el;
  }

  // SVG icons used inline (no font icons or deps)
  function iconArrow()  { return svg('<path d="M5 12h14M13 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>'); }
  function iconRotate() { return svg('<path d="M3 12a9 9 0 1 1 3 6.7M3 21v-5h5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>'); }
  function iconSpark()  { return svg('<path d="M12 3l1.9 4.6L18.5 9.5l-4.6 1.9L12 16l-1.9-4.6L5.5 9.5l4.6-1.9L12 3z" fill="currentColor"/>'); }
  function svg(inner) {
    const wrap = document.createElement('span');
    wrap.innerHTML = '<svg class="pf-icon" viewBox="0 0 24 24" aria-hidden="true">' + inner + '</svg>';
    return wrap.firstChild;
  }

  /* ------------------------------------------------------------
     State + render loop
     ------------------------------------------------------------ */
  const state = {
    step: 0,
    answers: Object.assign({}, defaultAnswers),
    result: null,
  };

  function render() {
    root.innerHTML = '';
    if (state.result) renderResult();
    else renderQuestion();
  }

  function renderQuestion() {
    const q = questions[state.step];
    const total = questions.length;
    const isLast = state.step === total - 1;
    const value = state.answers[q.key];
    // Current question counts as "in progress" — fills its own segment.
    const filledSegs = state.result ? total : state.step + 1;
    const progressPct = (filledSegs / total) * 100;

    // Progress bar — inline SVG so theme CSS can't touch the fills.
    // Thinner now (less visually loud than the slider) and the meta
    // labels above are gone — the segmented bar communicates progress.
    const filledPct = (filledSegs / total) * 100;
    const W = 600, H = 8;
    const fillW = (filledPct / 100) * W;
    const dividerRects = [];
    for (let i = 1; i < total; i++) {
      const x = (i / total) * W;
      dividerRects.push('<rect x="' + (x - 1) + '" y="0" width="2" height="' + H + '" fill="#ffffff"/>');
    }
    const bar = document.createElement('div');
    bar.className = 'pf-progress__svg';
    bar.style.borderRadius = '999px';
    bar.style.overflow = 'hidden';
    bar.innerHTML =
      '<svg width="100%" height="' + H + '" viewBox="0 0 ' + W + ' ' + H +
      '" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" style="display:block">' +
        '<rect width="' + W + '" height="' + H + '" fill="#dde4ee"/>' +
        '<rect width="' + fillW + '" height="' + H + '" fill="#285fa0"/>' +
        dividerRects.join('') +
      '</svg>';

    const card = h('div', { class: 'pf-card' },
      h('div', { class: 'pf-progress' },
        h('div', { class: 'pf-progress__meta' }, 'Question ' + (state.step + 1) + ' of ' + total),
        bar
      ),
      h('h2', { class: 'pf-question__title' }, q.title),
      sliderBlock(q, value),
      h('div', { class: 'pf-actions' },
        h('button', {
          class: 'pf-btn pf-btn--ghost',
          type: 'button',
          disabled: state.step === 0,
          onclick: () => { if (state.step > 0) { state.step--; render(); } },
        }, 'Previous'),
        h('button', {
          class: 'pf-btn pf-btn--primary',
          type: 'button',
          onclick: () => {
            if (isLast) {
              state.result = recommend(state.answers);
            } else {
              state.step++;
            }
            render();
            scrollIntoQuiz();
          },
        }, isLast ? 'See my match' : 'Next', iconArrow())
      )
    );

    root.appendChild(card);
  }

  function sliderBlock(q, value) {
    const fillPct = ((value - 1) / 4) * 100;

    // 5 dots in the slider track come from the CSS background (radial
    // gradients). Numbers live below the slider as their own row;
    // active one is bolded.
    const ticks = h('div', { class: 'pf-slider__ticks' },
      ...[1, 2, 3, 4, 5].map((n) => {
        const r = (n - 1) / 4;
        return h('span', {
          class: n === value ? 'is-active' : '',
          style: 'left: calc(15px + ' + r + ' * (100% - 30px))',
        }, String(n));
      })
    );

    const slider = h('input', {
      class: 'pf-slider',
      type: 'range',
      min: '1',
      max: '5',
      step: '1',
      value: String(value),
      'aria-label': q.title,
      style: '--pf-fill: ' + fillPct + '%',
      oninput: (e) => {
        const v = Number(e.target.value);
        state.answers[q.key] = v;
        e.target.style.setProperty('--pf-fill', ((v - 1) / 4) * 100 + '%');
        Array.from(ticks.children).forEach((t, i) =>
          t.classList.toggle('is-active', i + 1 === v));
      },
    });

    const endpoints = h('div', { class: 'pf-slider__endpoints' },
      h('span', null, q.lowLabel),
      q.midLabel ? h('span', null, q.midLabel) : null,
      h('span', null, q.highLabel),
    );

    return h('div', { class: 'pf-slider-block' },
      slider,
      ticks,
      endpoints
    );
  }

  function renderResult() {
    const r = state.result;
    const card = h('div', { class: 'pf-card pf-result' },
      // Clean "Your match" header — no dark bar, just breathing room
      h('div', { class: 'pf-result__head' },
        h('div', { class: 'pf-result__badge' }, iconSpark(), 'Your match'),
        h('h2', { class: 'pf-result__name' }, r.primary.name),
        h('p', { class: 'pf-result__summary' }, r.summary),
      ),
      h('div', { class: 'pf-result__products' },
        labeledProduct('Recommended', r.primary, true),
        r.pairing ? labeledProduct('Pair it with', r.pairing, false) : null,
        r.addon ? labeledProduct('Add-on', r.addon, false) : null,
        r.alternatives && r.alternatives.length
          ? h('div', { class: 'pf-alts' },
              h('div', { class: 'pf-alts__heading' }, 'Also worth considering'),
              h('div', { class: 'pf-alts__list' },
                ...r.alternatives.map((alt) => productBlock(alt, false))
              )
            )
          : null,
      ),
      h('div', { class: 'pf-result__restart' },
        h('button', {
          class: 'pf-btn pf-btn--outline',
          type: 'button',
          onclick: () => {
            state.step = 0;
            state.answers = Object.assign({}, defaultAnswers);
            state.result = null;
            render();
            scrollIntoQuiz();
          },
        }, iconRotate(), 'Start over')
      )
    );

    root.appendChild(card);

    // Async: hydrate live prices / sold-out badges
    hydrateProducts(card, [r.primary, r.pairing, r.addon, ...(r.alternatives || [])].filter(Boolean));
  }

  // A product card with its relationship label ("Recommended", "Pair it
  // with", etc.) rendered as a heading ABOVE the card — clearer separator
  // than tucking it inside the card's category line.
  function labeledProduct(label, product, accent) {
    return h('div', { class: 'pf-product-group' },
      label ? h('div', { class: 'pf-product-label' }, label) : null,
      productBlock(product, accent)
    );
  }

  // Whole-card link — hover lifts the card and animates the CTA arrow.
  // Single <a> wraps everything so there are no nested links. The category
  // (e.g. "Potty Seat") shows inside; the relationship label is above.
  function productBlock(product, accent) {
    const priceSlot = h('span', { class: 'pf-product__price-skel', 'data-price-skel': '1' });
    return h('a', {
        class: 'pf-product' + (accent ? ' pf-product--accent' : ''),
        href: product.url,
        'aria-label': product.name + ' — view product',
      },
      h('div', { class: 'pf-product__row' },
        h('div', { class: 'pf-product__imgwrap' },
          h('img', { class: 'pf-product__img', src: product.image, alt: product.name, loading: 'lazy' })
        ),
        h('div', { class: 'pf-product__content' },
          h('div', { class: 'pf-product__category' }, product.category),
          h('h3', { class: 'pf-product__name' }, product.name),
          h('div', { class: 'pf-product__pricerow', 'data-price-row': product.handle }, priceSlot),
          h('p', { class: 'pf-product__reason' }, product.reason),
          h('span', { class: 'pf-product__cta' }, 'View product ', iconArrow())
        )
      )
    );
  }

  function hydrateProducts(scope, products) {
    products.forEach((p) => {
      fetchProduct(p.handle).then((live) => {
        if (!live) {
          // Couldn't fetch — just drop the skeleton, no price shown
          scope.querySelectorAll('[data-price-row="' + cssEscape(p.handle) + '"]').forEach((row) => {
            row.innerHTML = '';
          });
          return;
        }
        scope.querySelectorAll('[data-price-row="' + cssEscape(p.handle) + '"]').forEach((row) => {
          row.innerHTML = '';
          row.appendChild(h('span', { class: 'pf-product__price' }, live.price));
          if (live.compareAtPrice) row.appendChild(h('span', { class: 'pf-product__compare' }, live.compareAtPrice));
          if (!live.available) row.appendChild(h('span', { class: 'pf-product__soldout' }, 'Sold out'));
        });
      });
    });
  }

  function cssEscape(s) {
    return (window.CSS && window.CSS.escape) ? window.CSS.escape(s) : String(s).replace(/"/g, '\\"');
  }

  function scrollIntoQuiz() {
    // Keep the user oriented when stepping forward/back on long pages
    const rect = root.getBoundingClientRect();
    if (rect.top < 0) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  render();
})();
